import React from 'react';
import Badge from 'react-bootstrap/Badge';
import {injectIntl} from 'react-intl';

import {labelFor} from './factLabels';

/**
 * Color del badge por nivel, de mayor a menor jerarquía. Siguen los colores
 * de la gráfica "Eventos por nivel" (verde, amarillo, azul, gris).
 */
export const BAND_VARIANTS = {
    featured: 'success',
    cooling: 'warning',
    candidate: 'info',
    none: 'secondary',
};

const UNKNOWN_BAND_VARIANT = 'light';

/**
 * El amarillo de Bootstrap (`warning`) es chillón y claro. Para "Enfriándose"
 * se usa un ámbar oscuro con texto blanco: contraste 4.92:1 (WCAG AA).
 */
const BAND_STYLES = {
    cooling: {backgroundColor: '#A16207', color: '#ffffff'},
};

/**
 * Nivel traducido dentro de un badge de color. Un nivel que el diccionario no
 * conoce se muestra crudo en un badge neutro.
 */
export function BandBadge({intl, band}) {
    if (!band) return null;

    return (
        <Badge
            variant={BAND_VARIANTS[band] || UNKNOWN_BAND_VARIANT}
            style={BAND_STYLES[band]}
            title={band}
            data-test='bandBadge'
        >
            {labelFor(intl, 'BAND', band)}
        </Badge>
    );
}

export default injectIntl(BandBadge);
